import { useEventListener } from "@redotech/react-util/event";
import { useHandler } from "@redotech/react-util/hook";
import { Location, unstable_useBlocker } from "react-router-dom";

export function usePrompt(message: string | null, blockQueryChanges = true) {
  unstable_useBlocker(
    useHandler(
      ({
        currentLocation,
        nextLocation,
      }: {
        currentLocation: Location;
        nextLocation: Location;
      }) => {
        if (message == null) {
          return false;
        }
        if (
          !blockQueryChanges &&
          currentLocation.pathname === nextLocation.pathname &&
          currentLocation.hash === nextLocation.hash
        ) {
          return false;
        }

        return !confirm(message);
      },
    ),
  );

  useEventListener(message !== null ? window : null, "beforeunload", (e) => {
    e.preventDefault();
    // https://bugs.chromium.org/p/chromium/issues/detail?id=866818
    e.returnValue = true;
  });

  // useEffect(() => {
  //   if (blocker.state === "blocked") {
  //     blocker.reset();
  //   }
  // }, [blocker]);
}
